import React from 'react';
import styled from 'styled-components';

import emptyStar from 'icons/empty-star.svg';
import fullStar from 'icons/full-star.svg';

export const StarIcon = styled.div.attrs(
  ({ size = 18, margin = 1.5, filled }) => ({
    style: {
      width: `${size}px`,
      height: `${size}px`,
      marginRight: `${margin}px`,
      background: `url(${
        filled ? fullStar : emptyStar
      }) center center / contain no-repeat`
    }
  })
)`
  position: relative;
  display: inline-block;
`;

const PartialStarContainer = styled.div.attrs(({ coverWidth }) => ({
  style: {
    width: `${coverWidth}%`
  }
}))`
  position: absolute;
  overflow: hidden;
`;

export const StarGroup = ({ filledStars, Star = StarIcon }) => {
  const stars = [];
  for (let i = 1; i <= 5; i += 1) {
    const remainingStars = Math.max(0, filledStars - (i - 1));
    let partialStar;
    if (remainingStars < 1 && remainingStars > 0) {
      partialStar = (
        <PartialStarContainer coverWidth={remainingStars * 100}>
          <Star margin={0} filled style={{ display: 'block' }} />
        </PartialStarContainer>
      );
    }
    stars.push(
      <Star key={i} filled={i <= filledStars}>
        {partialStar}
      </Star>
    );
  }

  return <div>{stars}</div>;
};
